module.exports = __webpack_public_path__ + "img/pt-22.fbc667ce.jpg";